import dotProp from 'dot-prop-immutable'
import copy from 'fast-copy'

import {
	AUTH_USER,
	GOT_USERDATA,
	USER_UPDATED,
	UNAUTH_USER,
	AUTH_ERROR,
	CHAT_OPENED,
	CHAT_TOGGLED,
	CHAT_CLOSED,
	TODODAY_ADDED,
	TODODAY_CHANGED,
	PAGE_TITLE_CHANGED
} from '../actions/types'

const INITIAL_STATE = {
	error: '',
	message: '',
	content: '',
	userDataRefreshed: false,
	authenticated: false,
	token: null,
	currentTododayIndex: 0,
	activeChats: [],
	chatFocusData: {},
	entities: [],
	userData: {},
	pageTitle: 'Hassl.',
	pendingInvitation: null,
	pendingNotification: null,
	currentAccountSlug: null,
	tempForcedUiColourState: -1,
	isSidebarShowingFavourites: false,
	onboarded_enums: [],
	hiddenCompleteProjectIds: []
}

export default function (state = INITIAL_STATE, action) {
	let chatIndex;
	let tempActiveChats
	let tempState = {
		...state
	}

	switch (action.type) {
		case AUTH_USER:
			tempState.pendingInvitation = null
			tempState.token = action.token
		case GOT_USERDATA:
		case USER_UPDATED:
			return {
				...tempState,
				userDataRefreshed: true,
				error: '',
				message: '',
				authenticated: true,
				userId: action.payload
			};
		case UNAUTH_USER:
			return {
				...INITIAL_STATE,
				authenticated: false,
				userData: null,
				currentAccount: null,
				token: null
			};
		case AUTH_ERROR:
			return {
				...state,
				error: action.payload
			};
		case TODODAY_ADDED:
			return {
				...state,
				currentTododayIndex: 0,
			}
		case TODODAY_CHANGED:
			return {
				...state,
				currentTododayIndex: action.index
			}
		case CHAT_OPENED: {
			tempActiveChats = copy(state.activeChats)

			if (!tempActiveChats) {
				tempActiveChats = []
			}

			const activeChatObject = {
				id: action.payload.id,
				isOpen: action.isOpen,
			}

			let replacingIndex = action.replacingIndex

			let activeChatIndex = null
			
			tempActiveChats.forEach((chat, index) => {
				if(chat.tempId == action.payload.id){
					replacingIndex = index
				}

				if(chat.id === action.payload.id){
					activeChatIndex = index
				}
			})

			if (typeof(activeChatIndex) == 'number') {
				tempActiveChats[activeChatIndex] = activeChatObject
			}else if(typeof(replacingIndex) == 'number'){
				tempActiveChats[replacingIndex] = activeChatObject
			} else {
				tempActiveChats.push(activeChatObject)
			}

			return {
				...state,
				activeChats: tempActiveChats
			}
		}
		case 'CHAT_TEMP_ID_CHANGED':
			tempActiveChats = copy(state.activeChats)

			tempActiveChats[action.payload.index].tempId = action.payload.tempId

			return {
				...state,
				activeChats: tempActiveChats,
				chatFocusData: {
					...state.chatFocusData,
					[state.userId]: action.payload.tempId !== null ? action.payload.tempId : action.payload.originalId
				}
			}
		case 'FOCUS_SET':
			let chatFocusData = copy(state.chatFocusData)

			chatFocusData[action.payload.userId] = action.payload.chatId

			return {
				...state,
				chatFocusData
			}
		case CHAT_TOGGLED:
			chatIndex = action.index;

			let isChatOpened = state.activeChats[chatIndex].isOpen

			state = dotProp.set(state, `activeChats.${chatIndex}.isOpen`, !isChatOpened)
		break
		case CHAT_CLOSED:
			chatIndex = action.index;

			state = dotProp.delete(state, `activeChats.${chatIndex}`);
		break
		case 'NOTIFICATION_PENDED':
			return {
				...state,
				pendingNotification: action.payload
			}
		case PAGE_TITLE_CHANGED:
			return {
				...state,
				pageTitle: action.payload
			}
		case 'INVITE_RECEIVED':
			return {
				...state,
				pendingInvitation: action.payload
			}
		case 'INVITE_DELETED':
			return {
				...state,
				pendingInvitation: null
			}
		case 'CLEARED_PENDING':
			return {
				...state,
				pendingInvitation: null,
				pendingNotification: null
			}
		case 'EMAIL_VALIDATED':
			let validationText = ''

			switch(action.payload){
				case 404:
					validationText = "Your validated account can't be found."
					break
				case 422:
					validationText = "This address has already been confirmed."
					break
				case 200:
					validationText = "Your email address has been confirmed."
					break
			}

			return {
				...state,
				emailValidation: {
					text: validationText,
					status: action.payload
				},
				forceHideActivation: false
			}
		case 'EMAIL_VALIDATION_CLEARED':
			return {
				...state,
				emailValidation: null,
				forceHideActivation: true
			}
		case 'SET_TEMP_UI_COLOUR':
			return {
				...state,
				tempForcedUiColourState: action.payload
			}
		case 'REFERRER_SET':
			return {
				...state,
				referrer: action.payload
			}
		case 'UNSUBSCRIBED':
			return {
				...state,
				unsubscribeData: action.payload
			}
		case 'PLAN_AND_CURRENCY_OBTAINED':
			return {
				...state,
				planAndCurrencyData: action.payload
			}
		case 'SET_FAVOURITES_VISIBILITY':
			return {
				...state,
				isSidebarShowingFavourites: !state.isSidebarShowingFavourites
			}
		case 'SET_ONBOARDED_ENUM':
			const onboarded_enums = [...state.onboarded_enums]

			if(onboarded_enums.indexOf(action.payload) == -1){
				onboarded_enums.push(action.payload)
			}

			return {
				...state,
				onboarded_enums
			}
		case 'CLEAR_ONBOARDED_ENUMS':
			return {
				...state,
				onboarded_enums: []
			}
		case 'TOGGLE_SEE_COMPLETE':
			const hiddenCompleteProjectIds = [...state.hiddenCompleteProjectIds]
			const indexOfProjectIfExists = hiddenCompleteProjectIds.indexOf(action.payload)

			if(indexOfProjectIfExists == -1){
				hiddenCompleteProjectIds.push(action.payload)
			}else{
				hiddenCompleteProjectIds.splice(indexOfProjectIfExists, 1)
			}

			return {
				...state,
				hiddenCompleteProjectIds
			}
		case 'GOT_WELLNESS_DATA':

			return {
				...state,
				wellnessData: {
					...action.payload
				}
			}
		case 'SET_BIG_CHAT_OPEN':
			return {
				...state,
				isBigChatOpen: action.payload
			}
	}

	return state
}



// WEBPACK FOOTER //
// ./src/state/reducers/auth-reducer.jsx